import axios from "axios"
import clienteAxios from "../config/clienteAxios"

const getGeneralFaqs = async () => {
  let response
  try {
    response = await axios.get(
      `${process.env.REACT_APP_BACKEND_API}/faq`
    )
    return response
  } catch (error) {
    console.log(error)
  }
}

const UpdateFaqs = async (values) => {
    let response
  try {
    response = await clienteAxios.put("/faq", values)
  } catch (error) {
    console.log(error)
  }
  return response
}
const DeleteFaqs = async (values) => {
    let response
  try {
    response = await clienteAxios.put("/faq", values)
  } catch (error) {
    console.log(error)
  }
  return response
}

const CreateFaqs = async (values) => {
    let response
  try {
    response = await clienteAxios.post("/faq", values)
  } catch (error) {
    console.log(error)
  }
  return response
}

export {getGeneralFaqs, UpdateFaqs, CreateFaqs, DeleteFaqs}
